import { configureStore } from "@reduxjs/toolkit";
import artifactReducer from "./artifactSlice";
import storyBoardGenerationReducer from "./storyBoardGenerationSlice";

export const store = configureStore({
  reducer: {
    artifact: artifactReducer,
    storyBoardGeneration: storyBoardGenerationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
